import { SearchResultsBannerFragment } from '@graphql/generated-contentful/graphql';
import {
  SearchResultsBanner,
  SearchResultsBannerDisplayType,
} from '@lib/types/search/SearchResultsBanner';
import { isDefined } from './isDefined';

export const mapContentfulSearchResultsBanners = (
  banners: Array<SearchResultsBannerFragment | null>
): SearchResultsBanner[] => {
  return banners
    .map((banner) => {
      if (
        !banner ||
        !banner.image ||
        !banner.image.url ||
        !banner.link ||
        !banner.link.url
      ) {
        return null;
      }
      return {
        image: {
          url: banner.image.url,
          alt: banner.image.description ?? '',
        },
        mobileImage: banner.mobileImage?.url
          ? {
              url: banner.mobileImage.url,
              alt: banner.mobileImage.description ?? '',
            }
          : undefined,
        link: {
          href: banner.link.url,
          value: '', // value is not used since the link is an image
          openInNewTab: Boolean(banner.link.openInNewTab),
        },
        displayType:
          (banner.displayType as SearchResultsBannerDisplayType) ??
          SearchResultsBannerDisplayType.DEFAULT,
      };
    })
    .filter(isDefined);
};
